module.exports = "/assets/dist/images/bodystyles_convertibles.png?8a81e2a9430813d552cbfdce5a7263d6";